module.exports = __webpack_public_path__ + "static/media/homelogo.abbb4d65.png";